/**
 * Everything a member may open without being assigned it: live and listed.
 *
 * An unlisted course is reachable by its address and deliberately absent here;
 * that is the whole difference between the two visibilities, and it is the
 * server's filter, not this page's.
 */

import { learn } from '../api';
import { BundleTile, CourseTile, TileGrid } from '../components/Bits';
import { Empty, ErrorNote, Loading, PageTitle, Panel, PanelHead } from '../components/Chrome';
import { plural } from '../theme';
import { useLoad } from '../useLoad';

export default function Catalogue() {
  const { data, error, loading } = useLoad(() => learn.catalogue(), 'Could not load the catalogue.');

  if (error) return <ErrorNote>{error}</ErrorNote>;
  if (!data) return loading ? <Loading /> : null;

  if (data.courses.length === 0 && data.bundles.length === 0) {
    return (
      <>
        <PageTitle title="Catalogue." />
        <Empty line="Nothing has been published for everyone yet." />
      </>
    );
  }

  return (
    <>
      <PageTitle
        title="Catalogue."
        meta={[
          data.courses.length > 0 ? plural(data.courses.length, 'course') : null,
          data.bundles.length > 0 ? plural(data.bundles.length, 'bundle') : null
        ]
          .filter(Boolean)
          .join(' · ')}
      />

      {data.bundles.length > 0 && (
        <Panel style={{ display: 'grid', gap: 16 }}>
          <PanelHead title="Bundles" />
          <TileGrid>
            {data.bundles.map((b) => (
              <BundleTile key={b.id} bundle={b} />
            ))}
          </TileGrid>
        </Panel>
      )}

      {data.courses.length > 0 && (
        <Panel style={{ display: 'grid', gap: 16 }}>
          <PanelHead title="Courses" />
          <TileGrid>
            {data.courses.map((c) => (
              <CourseTile key={c.id} course={c} />
            ))}
          </TileGrid>
        </Panel>
      )}
    </>
  );
}
